import React from "react";
import Button from "@mui/material/Button";

export default function NonIconButton(props) {
  const clickEvent = props.clickEvent;
  return (
    <Button
      variant="contained"
      buttonstyle={{ borderRadius: 25 }}
      style={{ borderRadius: 25 }}
      sx={{
        color: "white",
        fontSize: "14px",
        fontWeight: "bold",
        backgroundColor: "#28345e",
        py: "10px",
        px: "20px",
        width: "100%",
        "&:hover": {
          background: "#8bb6c6",
        },
      }}
      onClick={() => clickEvent()}
      disabled={props.disabled}
    >
      {props.title}
    </Button>
  );
}
